import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Customer, CustomersFilters } from '../../../commons/models/customer';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-customers-filters',
  templateUrl: './customers-filters.component.html',
  styleUrls: ['./customers-filters.component.scss']
})
export class CustomersFiltersComponent {
    @Output()
    onFilter: EventEmitter<CustomersFilters> = new EventEmitter();

    @Output()
    onLoad: EventEmitter<any> = new EventEmitter<any>();

    @Input() customers: Customer[];


    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    private _defaultFilters: CustomersFilters;
    filtersForm: FormGroup;
    defaultTenant: boolean = true;


    constructor(private fb: FormBuilder) {
        this._createForm();
    }

    private _createForm() {
        let group = {
            filter: "",
            onlyCurrentTenant: [true]
        }

        this.filtersForm = this.fb.group(group);
    }

    applyFilters(){
        this.onFilter.emit(this._getFilters());
    }

    private _getFilters(): CustomersFilters {
        let filters: CustomersFilters = {};
        if (this.filtersForm) {
            const values = this.filtersForm.value;
            filters.filter = values.filter;
            filters.onlyCurrentTenant = values.onlyCurrentTenant;
        }
        return filters;
    }

    resetFilters(){
        this.filtersForm.reset();
        this.filtersForm.patchValue({
            filter: "",
            onlyCurrentTenant: true
        });
        this._setDefaultValues();
        this.applyFilters();
    }

    get defaultFilters(): CustomersFilters {
        return this._defaultFilters;
    }

    @Input()
    set defaultFilters(defaultFilters: CustomersFilters) {
        this._defaultFilters = defaultFilters;
        this._setDefaultValues();
    }

    private _setDefaultValues() {
        if (this.defaultFilters) {
            if (this.filtersForm) {
                this.filtersForm.patchValue({
                    filter: this.defaultFilters.filter,
                    onlyCurrentTenant: this.defaultFilters.onlyCurrentTenant
                });
            }
        }
    }


}
